import React from 'react';
import { Box, SimpleGrid, Text, Heading, Image } from '@chakra-ui/react';
import BenefitBg from '../../assets/Landing/Benefitsbg.png';
import Benefits01 from '../../assets/Landing/Benefits01.svg';
import Benefits02 from '../../assets/Landing/Benefits02.svg';
import Benefits03 from '../../assets/Landing/Benefits03.svg';

function BenefitContent({ title, text, imgSrc }) {
  return (
    <Box paddingY={8} textAlign="left">
      <Image src={imgSrc} alt={`${title} icon`} width="124.028px" height="126.386px" />
      <Heading
        color="#0D1216"
        fontFamily="Quicksand"
        fontSize="24px"
        fontWeight="700"
        lineHeight="32px"
        marginTop={4}
      >
        {title}
      </Heading>
      <Text
        color="#313C45"
        fontFamily="Quicksand"
        fontSize="16px"
        fontWeight="500"
        lineHeight="25px"
        letterSpacing="0.08em"
        marginTop={2}
      >
        {text}
      </Text>
    </Box>
  );
}

function Benefits() {
  return (
    <Box
      bgImage={`url(${BenefitBg})`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      backgroundBlendMode="overlay"
      width="full"
      paddingY="55px"
      position="relative"  // Ensure the component respects its container
      id="Features"
    >
      <SimpleGrid
        columns={{ base: 1, md: 3 }} // Using base for better clarity
        spacing={10}
        spacingY="30px"
        width={{ base: "90%", md: "80%" }}
        maxWidth="1440px"
        marginX="auto"
        padding={{ base: "30px", md: "62px 30px" }}
        justifyContent="center"
        alignItems="center"
        bg="white"
        boxShadow="0px 10px 25px 0px rgba(138, 138, 138, 0.10)"
        borderRadius="12px"
      >
        <BenefitContent
          imgSrc={Benefits01}
          title="Learn to Identify Emotions"
          text="TEA provides engaging activities and exercises to help children with ASD recognize and understand various emotions, empowering them to navigate social interactions with confidence."
        />
        <BenefitContent
          imgSrc={Benefits02}
          title="View Progress Reports"
          text="Parents and caregivers can track their child's progress and achievements over time with detailed progress reports, allowing them to celebrate milestones and identify areas for further development."
        />
        <BenefitContent
          imgSrc={Benefits03}
          title="Personalized Learning"
          text="TEA offers customizable teaching and learning methods tailored to each child's unique needs and preferences, ensuring a personalized and effective learning experience."
        />
      </SimpleGrid>
    </Box>
  );
}

export default Benefits;